import { render, staticRenderFns } from "./InventoriesMarketAreasTable.vue?vue&type=template&id=027ab56e&scoped=true&"
import script from "./InventoriesMarketAreasTable.vue?vue&type=script&lang=ts&"
export * from "./InventoriesMarketAreasTable.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesMarketAreasTable.vue?vue&type=style&index=0&id=027ab56e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027ab56e",
  null
  
)

export default component.exports